import { createSlice } from "@reduxjs/toolkit";

export const editOfficeSlice = createSlice({
    name:"editOffice",
    initialState: {
        showEditOfficeModal:false,
        selectedOffice:null,
    },
    reducers:{
        setShowEditOfficeModal: (state) => {
            state.showEditOfficeModal = !state.showEditOfficeModal;
        },
        setSelectedOffice: (state, action)=> {
            state.selectedOffice = action.payload;
        },
        resetEditOffice: (state)=> {
            state.showEditOfficeModal = false;
            state.selectedOffice = null;
        },
    }
});

export const { setShowEditOfficeModal, setSelectedOffice, resetEditOffice } = editOfficeSlice.actions;

export default editOfficeSlice.reducer;